import React from "react";

const Fallback = ({ loading, fallback, children }) => {
  const Placeholder = () => fallback;
  return loading ? <Placeholder></Placeholder> : <div>{children}</div>;
};

export default Fallback;
